var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"songs-filter"}},[_c('IconClockBack',{class:{ active: _vm.songsFilterNonPlayed },nativeOn:{"click":function($event){return _vm.toggleFilterNonPlayed.apply(null, arguments)}}}),(_vm.songsFilterNonPlayed)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('song.filter.nonPlayed'))}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }